import { render, staticRenderFns } from "./MultipleAccountSelection.vue?vue&type=template&id=12c5dd45&scoped=true"
import script from "./MultipleAccountSelection.vue?vue&type=script&lang=ts"
export * from "./MultipleAccountSelection.vue?vue&type=script&lang=ts"
import style0 from "./MultipleAccountSelection.vue?vue&type=style&index=0&id=12c5dd45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c5dd45",
  null
  
)

export default component.exports